module.exports = __webpack_public_path__ + "img/popup2.f758e8c9.png";